<template>
  <layout>
    <h4>
      Pages
      <router-link
        :to="{ name: 'pages.create' }"
        class="btn btn-sm btn-primary">Create
      </router-link>
    </h4>
    <pages-base-table
      :resource="resource">

      <template
        slot="title"
        slot-scope="{ item }">
        <a
          :href="item.link"
          target="_blank">
          {{ item.title }}
        </a>
      </template>

    </pages-base-table>
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import PagesBaseTable from '../components/PagesBaseTable.vue';
import Proxy from './Proxy';

const resourceBase = 'pages';

export default {
  name: 'PagesIndex',

  components: {
    Layout,
    PagesBaseTable,
  },

  data() {
    return {
      resource: {
        base: resourceBase,
        proxy() {
          return new Proxy();
        },
        beforeItemsRequest: (res) => {

          if (res.parameters.per_page_custom) {
            this.resource.perPage = res.parameters.per_page_custom;
          }
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        category: 0,
        fields: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'locale',
            label: 'Locale',
            sortable: true
          },
          {
            key: 'title',
            label: 'Title',
            sortable: true,
          },
          {
            key: 'created_at',
            label: 'Created',
            sortable: true,
          },
        ],
        searchFields: [
          {
            attribute: 'query',
            component: 'text-field',
            type: 'search',
            placeholder: 'Search ...',
            value: '',
          },
          {
            name: "status-field",
            attribute: "generated",
            component: "select-field",
            placeholder: "Filter by generated",
            label: "Generated",
            value: '',
            required: false,
            options: [
              {
                label: "All",
                value: ""
              },
              {
                label: "Generated only",
                value: "all"
              },
              {
                label: "Manual only",
                value: "manual"
              }
            ]
          },
          {
            component: 'select-field',
            attribute: 'per_page_custom',
            placeholder: 'Per items on page',
            ajax: false,
            required: false,
            value: '',
            options: [
              {
                label: "20",
                value: 20
              },
              {
                label: "50",
                value: 50
              },
              {
                label: "100",
                value: 100
              },
              {
                label: "500",
                value: 500
              },
            ]
          },

        ],
        rowActions: item => {
          let actions = [
            {
              type: "link",
              label: 'Edit',
              link: this.$router.resolve({
                name: `${resourceBase}.edit`,
                params: {
                  id: item.id
                }
              }).href
            }
          ];
          actions.push("delete");
          return actions;
        },
      },
    };
  },
  created() {
    this.getGeneratedTemplates();
  },
  methods: {
    getGeneratedTemplates() {
      let vm = this;
      let api = new Proxy({per_page: 1000});
      let promise = api.submit('get', `/${resourceBase}-generator`, {}).then((res) => {
        if (res.data.length) {
          res.data.forEach(function (el, i) {
            vm.resource.searchFields[1].options.push({
              label: el.title,
              value: el.id
            })
          })

        }
      });
    }
  }

};
</script>
